import React from 'react';

function FJVip(props) {
  const {id1, id2} = props;
  return (
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20px" height="20px"
         viewBox="0 0 20 20">
      <linearGradient id={id1} gradientUnits="userSpaceOnUse" x1="-1802.6" y1="212" x2="-1802.6"
                      y2="213" gradientTransform="matrix(20 0 0 5 36062 -1058)">
        <stop offset="0" style={{stopColor: "#FFD54E"}}/>
        <stop offset="1" style={{stopColor: "#FFA00A"}}/>
      </linearGradient>
      <polygon fill={`url(#${id1})`} points="5.476,2 14.524,2 20,7 0,7 "/>
      <linearGradient id={id2} gradientUnits="userSpaceOnUse" x1="-1802.6" y1="96.3636" x2="-1802.6"
                      y2="97.3636" gradientTransform="matrix(20 0 0 11 36062 -1053)">
        <stop offset="0" style={{stopColor: "#FFD878"}}/>
        <stop offset="1" style={{stopColor: "#FFA00A"}}/>
      </linearGradient>
      <polygon fill={`url(#${id2})`} points="0,7 20,7 10,18 "/>
    </svg>
  );
}

export default FJVip;